import React from 'react';
import { View } from 'react-native';
import { BasicText, StrongText } from '../Styles';

const AddressBlock = ({title = undefined, address = undefined, city = undefined, postalCode = undefined, province = undefined, country = undefined}) => {
    return <View>
        <StrongText>{title}</StrongText>
        <BasicText>{address}</BasicText>
        <BasicText>{city} {province} {postalCode}</BasicText>
        <BasicText>{country}</BasicText>
    </View>
}

export default AddressBlock;